export default __webpack_public_path__ + "static/media/pic2.f8dec13d.jpg";